import { Component } from '@angular/core';
import { CommoditiesTableFilterComponent } from '../commodities-table-filter/commodities-table-filter.component';
import { CommoditiesTableComponent } from '../commodities-table/commodities-table.component';

@Component({
  selector: 'app-commodities-page',
  imports: [
    CommoditiesTableFilterComponent,
    CommoditiesTableComponent
  ],
  templateUrl: './commodities-page.component.html',
  styleUrl: './commodities-page.component.scss'
})
export class CommoditiesPageComponent {

}
